import { Mask, Toast } from 'antd-mobile';
import { Fragment, useEffect, useState } from 'react';
import activity from '@/assets/images/activity.png';
import centro from '@/assets/images/centro.png';
import purpleBox from '@/assets/images/purpleBox.png';
import yellowBox from '@/assets/images/yellowBox.png';
import inviteeBox from '@/assets/images/inviteeBox.png';
import {
  getInviteeRewardList,
  inviteeReceiveReward,
  isExitRecharge,
  isExitReward,
  receiveRecharge,
  receiveReward
} from '@/api';
import { useTranslation } from 'react-i18next';
import { formatter } from '@/utils/mathWays';
import { useUserInfo } from '@/store';
import { useActivate } from 'react-activation';
import { getS3Url } from '@/utils';

const ActivityContent = () => {
  const { t } = useTranslation();
  const userInfo = useUserInfo.getState();
  const [visible, setVisible] = useState(false);
  const [showBonus, setShowBonus] = useState(false);
  const [amountBonus, setAmountBonus] = useState(0);
  const [bonusParam, setBonusParam] = useState({});
  const [showActivation, setShowActivation] = useState(false);
  const [amountActivation, setAmountActivation] = useState(0);
  const [activationParam, setActivationParam] = useState({});
  const [inviteeRewardList, setInviteeRewardList] = useState([]) as any[];
  const [inviteeRewardVisible, setInviteeRewardVisible] = useState(false);

  useEffect(() => {
    if (userInfo.token) {
      queryReward();
    }
  }, []);

  useActivate(() => {
    if (userInfo.token) {
      queryReward();
    }
  });

  useEffect(() => {
    if (!inviteeRewardVisible && !showActivation && !showBonus) {
      console.log('关闭弹窗');
      setVisible(false);
    }
  }, [inviteeRewardVisible, showActivation, showBonus]);
  // 彩金领取
  const receiveBonus = async () => {
    const { code, data } = await receiveRecharge(bonusParam);
    if (code === 200 && data) {
      Toast.show({
        icon: 'success',
        content: t('successMsg')
      });
      setShowBonus(false);
      // if (!showActivation) {
      //   setVisible(false);
      // }
    } else {
      Toast.show({
        icon: 'fail',
        content: t('Falha')
      });
    }
  };

  // 激活领取
  const receiveActivation = async (props: any) => {
    const params = props
      ? {
          activationId: props.activationId,
          recordId: props.recordId
        }
      : activationParam;
    const { code, data } = await receiveReward(params);
    if (code === 200 && data) {
      Toast.show({
        icon: 'success',
        content: t('successMsg')
      });
      setShowActivation(false);
      // if (!showBonus) {
      //   setVisible(false);
      // }
    }
  };

  const _inviteeReceiveReward = async item => {
    const params = new FormData();
    params.append('rewardId', item.id);
    const result = await inviteeReceiveReward(params);
    if (result.code === 200) {
      if (result.data) {
        const _inviteeRewardList = inviteeRewardList.filter(
          cItem => cItem.id !== item.id
        );
        setInviteeRewardList(_inviteeRewardList);
        if (_inviteeRewardList.length === 0) {
          setInviteeRewardVisible(false);
        }
      } else {
        Toast.show({
          icon: 'fail',
          content: t('Falha')
        });
      }
    }
  };

  // 查询是否存在奖励
  const queryReward = async () => {
    // 彩金直充奖励查询
    const res = await isExitRecharge();
    if (res?.data?.batchId && res?.data?.recordId) {
      setShowBonus(true);
      setBonusParam({
        batchId: res?.data?.batchId,
        recordId: res?.data?.recordId
      });
      setAmountBonus(res?.data?.amount);
      setVisible(true); // 只要存在奖励就显示领取弹窗
    }
    // 查询是否存在激活奖励
    const result = await isExitReward();
    // console.log('查询是否存在奖励', res, result);
    if (result.code === 200 && result?.data) {
      setAmountActivation(result?.data?.amount);
      setActivationParam({
        activationId: result?.data?.activationId,
        recordId: result?.data?.recordId
      });
    }
    // 自动领取
    if (result?.data?.grantType === 1) {
      receiveActivation(result?.data);
    }
    // 手动领取
    if (result?.data?.grantType === 0) {
      setShowActivation(true);
      setVisible(true); // 只要存在奖励就显示领取弹窗
    }
    const inviteeRewardListRes = await getInviteeRewardList();
    if (
      inviteeRewardListRes?.code === 200 &&
      inviteeRewardListRes?.data?.length > 0
    ) {
      setVisible(true);
      setInviteeRewardList(inviteeRewardListRes?.data);
      setInviteeRewardVisible(true);
    }
    console.log('查询被邀请人奖励列表', inviteeRewardList);
  };

  return (
    <>
      {/* {(showBonus || showActivation) && (
        <img
          className="w-[130px] h-[130px] fixed right-0 bottom-[150px]"
          src={activity}
          onClick={() => {
            setVisible(true);
          }}
          alt=""
        />
      )} */}
      <Mask visible={visible} className="pdd-share-content">
        <div className="centro mt-[-100px] pt-[100px] pb-[20px] relative bg-gradient-to-b from-[#2F2F2F] to-[#000] w-[100%] rounded-[20px]">
          <img
            onClick={() => {
              setVisible(false);
            }}
            src={getS3Url('home/i_10.png')}
            className="w-10 h-10 absolute left-[50%] bottom-[-50px] ml-[-20px]"
          />
          {/* <img
            className="absolute top-[-200px] w-[320px]"
            src={centro}
            alt=""
          /> */}
          {/* <div
            onClick={() => {
              setVisible(false);
            }}
            className="w-[36px] h-[36px] absolute top-[10px] right-[10px] rounded-[50%] bg-[#000] opacity-50 text-[#fff] text-[32px] text-center leading-[36px]"
          >
            ×
          </div> */}
          <div className="px-8">
            {showBonus && (
              <div className="centroItem text-center">
                <div className="text-[#fff] pt-[12px]">
                  <p className="text-[11px] h-[35px] leading-5">DAR DINHEIRO</p>
                  <div className="flex h-[32px] items-center mb-[4px]">
                    <img
                      className="w-[40px] h-[24px]"
                      src={getS3Url('home/b11.png')}
                      alt=""
                    />
                  </div>
                  <p className="text-[15px] font-bold text-[#F9C486] leading-[20px]">
                    {formatter.format(amountBonus)}{' '}
                    <span className="text-[11px] font-normal">R$</span>
                  </p>
                </div>

                <div
                  onClick={() => {
                    receiveBonus();
                  }}
                  className="btn"
                >
                  RECEBER
                </div>
              </div>
            )}

            {showActivation && (
              <div className="centroItem text-center">
                {/* <img className="w-[70px] h-[62px]" src={yellowBox} alt="" /> */}
                <div className="text-[#fff] pt-[12px]">
                  <p className="text-[11px] h-[36px] leading-5">
                    ATIVAR RECOMPENSA
                  </p>
                  <div className="flex h-[32px] items-center mb-[4px]">
                    <img
                      className="w-[40px] h-[24px]"
                      src={getS3Url('home/b11.png')}
                      alt=""
                    />
                  </div>
                  <p className="text-[15px] font-bold text-[#F9C486] leading-[20px]">
                    {formatter.format(amountActivation)}{' '}
                    <span className="text-[11px] font-normal">R$</span>
                  </p>
                </div>
                <div
                  onClick={() => {
                    receiveActivation('');
                  }}
                  className="btn"
                >
                  RECEBER
                </div>
              </div>
            )}

            {inviteeRewardVisible &&
              inviteeRewardList.map((item: any) => (
                <Fragment key={item.id}>
                  <div className="centroItem text-center">
                    {/* <img
                      className="w-[70px] h-[62px]"
                      src={inviteeBox}
                      alt=""
                    /> */}
                    <div className="text-[#fff] pt-[12px]">
                      <p className="text-[11px] h-[36px] leading-5">
                        SER CONVIDADO
                      </p>
                      <div className="flex h-[32px] items-center mb-[4px]">
                        <img
                          className="w-[40px] h-[24px]"
                          src={getS3Url('home/b11.png')}
                          alt=""
                        />
                      </div>
                      <p className="text-[15px] font-bold text-[#F9C486] leading-[20px]">
                        {formatter.format(item.awardAmt)}{' '}
                        <span className="text-[11px] font-normal">R$</span>
                      </p>
                    </div>
                    <div
                      onClick={() => {
                        _inviteeReceiveReward(item);
                      }}
                      className="btn"
                    >
                      RECEBER
                    </div>
                  </div>
                </Fragment>
              ))}
          </div>
        </div>
      </Mask>
    </>
  );
};

export default ActivityContent;
